export const processSite = () => {
  return 'shop.personalcollection.com.my'
}